import StrategyIcon from './StrategyIcon'

export default StrategyIcon
